import { useMemo } from "react";

import { DataTable } from "components/ui/DataTable";
import { Pill } from "components/ui/Pill/Pill";
import { formatDate } from "utils/dateFormatter";

const STATUS_CONFIG = {
  SENT: { color: "var(--green-900)", bg: "#e7efeb", border: "var(--green-900)", label: "Sent" },
  ACCEPTED: { color: "var(--green-900)", bg: "#e7efeb", border: "var(--green-900)", label: "Accepted" },
  REJECTED: { color: "#b70000", bg: "#ffe8e8", border: "#b70000", label: "Rejected" },
  DRAFT: { color: "#756800", bg: "#efefe7", border: "#756800", label: "Draft" },
  ERROR: { color: "#b70000", bg: "#ffe8e8", border: "#b70000", label: "Error" },
};

const normalizeStatus = (status) =>
  ["INTEGRATED_BROWSER", "DRAFT"].includes(status) ? "DRAFT" : status;

export const ConsultationReferralsTable = ({ referrals }) => {
  const columns = useMemo(
    () => [
      {
        id: "date",
        header: "Date",
        width: "180px",
        render: (row) => formatDate(row.date) ?? "-",
      },
      {
        id: "hospital",
        header: "Hospital",
        flexGrow: 1,
        render: (row) => row.hospital ?? "-",
      },
      {
        id: "referralType",
        header: "Referral Type",
        flexGrow: 1,
        render: (row) => row.referralName || row.referralType || "-",
      },
      {
        id: "status",
        header: "Status",
        width: "140px",
        render: (row) => {
          const key = normalizeStatus(row.status);
          const cfg = STATUS_CONFIG[key] ?? {
            color: "var(--gray-600)",
            bg: "var(--gray-100)",
            border: "var(--gray-300)",
            label: key || "-",
          };
          return (
            <Pill color={cfg.color} bg={cfg.bg} border={cfg.border}>
              {cfg.label}
            </Pill>
          );
        },
      },
    ],
    []
  );

  return (
    <DataTable
      columns={columns}
      data={referrals ?? []}
      getRowId={(row) => row.id}
      emptyTitle="No referrals found"
      emptyText="No referrals for this consultation."
      rowsPerPage={20}
      rowsOptions={[5, 10, 20, "All"]}
    />
  );
};
